import React from 'react'
import { Helmet } from '@dr.pogodin/react-helmet'

import { Grid, LinearProgress, Divider as MuiDivider, Typography } from '@mui/material'

import { spacing } from '@mui/system'
import styled from '@emotion/styled'
import { useLoaderData } from 'react-router'
import InvestorHistory from './InvestorHistory'
import InvestorYearlyOverview from './InvestorYearlyOverview'
import { InvestorDetails as InvestorDetailsInterface } from '../../api/InvestorApi'
import { WatchListButton } from '../components/WatchListButton'

const Divider = styled(MuiDivider)(spacing)

function InvestorDetails() {
    const investorDetails = useLoaderData()

    if (!investorDetails) {
        return <LinearProgress />
    }

    return (
        <>
            <Helmet title={investorDetails.name} />
            <Typography
                variant='h3'
                gutterBottom
                sx={{
                    display: 'inline',
                }}
            >
                {investorDetails.name}
                <WatchListButton
                    entityId={investorDetails.id}
                    isInWatchList={!!investorDetails.isInWatchList}
                    type='Investor'
                />
            </Typography>
            <Divider my={6} />
            <Grid container spacing={6}>
                <Grid size={12}>
                    <InvestorYearlyOverview investor={investorDetails} />
                </Grid>
                <Grid size={12}>
                    <InvestorHistory investor={investorDetails} />
                </Grid>
            </Grid>
        </>
    )
}

export default InvestorDetails
